import {Injectable} from "@angular/core";
import {
  BokkzBezwaarDataService,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BezwaarEntity, BokkzBezwaarClient} from "./api.bokkz.bezwaar";

@Injectable({providedIn: 'root'})
export class BokkzBezwaarLogic {

  public bezwaarEntityList= {} as BezwaarEntity[];
  public bezwaarEntity= {} as BezwaarEntity;

  constructor(private bokkzClient: BokkzBezwaarClient,
              public dataService: BokkzBezwaarDataService,
  ) {
    this.dataService.bezwaarEntityList.subscribe((value) => (this.bezwaarEntityList = value));
    this.dataService.bezwaarEntity.subscribe((value) => (this.bezwaarEntity = value));
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private getEntity() : BezwaarEntity {
    return this.getFromSessionStorage('bezwaarEntity') || <BezwaarEntity>{};
  }
}
